"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  rightShip: {
    menuName: 'Right Ship',
    updateTime: 'Update Time',
    ratingTime: 'Rating Time',
    vessel: 'Vessel',
    safetyRating: 'Safety Rating',
    ghgRating: 'GHG Rating',
    detail: "Detail",
    queryHistory: 'History Rating'
  },
  amcl: {
    menuName: 'Digital and Energy Saving Technologies',
    totalCount: 'Total',
    pleaseInput: 'Please input',
    tipNoSelection: 'No item selected',
    tipNoData: 'No item can export'
  },
  standardCodeCommon: {
    standardCode: 'Standardized Code',
    portMile: 'Port Mile',
    activeFlag: 'Status',
    effect: 'Effect',
    invalid: 'Invalid',
    effect2: 'Enabled',
    invalid2: 'Invalid',
    pleaseEnter: 'PleaseEnter',
    pleaseInput: 'PleaseInput',
    pleaseChoose: 'PleaseChoose',
    remark: 'Remark',
    optionDate: 'Option Date',
    selectTime: 'Select Time',
    saveSuccessfully: 'Save Successfully',
    failSave: 'Fail to save',
    countryAreaCode: 'Country AreaCode',
    alreadyExistsCanSave: 'Already exists! Can not save',
    updateSuccessfully: 'Update Successfully',
    searchFailure: 'Search Failure',
    hint: 'Are you sure to delete this item?',
    hintSome: 'Are you sure to delete some item?',
    hintSome2: 'The current page modification has not been saved. Do you want to save and calculate?',
    hintSome3: 'Please confirm that the data is correct and proceed with the calculation',
    hintTitle: 'Hint Title',
    yes: 'Yes',
    no: 'No',
    successfullyDelete: 'Successfully delete',
    sure: 'Are you sure you want to',
    thisData: ' Validate this data?',
    modifySuccessfully: 'Modify successfully',
    pleaseSelectData: 'Please Select a Piece Of Data',
    notBeEmpty: 'Can not be empty',
    characterSize1: 'The length is between 1 and 20 characters',
    characterSize2: 'The length is between 1 and 100 characters',
    characterSize3: 'The length is between 1 and 200 characters',
    characterSize4: 'The length is between 1 and 500 characters',
    characterSize5: 'The length is between 1 and 50 characters',
    characterSize6: 'The length is between 1 and 10 characters',
    characterSize7: 'The length is between 1 and 1000 characters',
    pleaseSelectCountry: 'Please select country',
    pleaseSelectStatus: 'Please select status',
    failDelete: 'Fail to delete',
    currencyCheckout: 'The currency code you entered already exists and cannot be saved',
    currencyNameCheckout: 'The currency name you entered already exists and cannot be saved',
    companyCodeCheckout: 'The company code you entered already exists and cannot be saved',
    bankCodeCheckout: 'The bank code you entered already exists and cannot be saved',
    selectSpecificTime: 'Please select a specific time',
    failedSaveChild: 'Failed to save child table',
    singleCompany: 'Single Vessel Company',
    perfectForm: 'Please perfect the form',
    typeAlready: 'The type already exists',
    completeFormCheckout: 'Cannot be empty, please complete the form',
    overlength: 'overlength',
    selectedCheckout: 'Whether to delete the selected items',
    operateSuccessfully: 'Operate successfully',
    operationFailure: 'Operation failure',
    deletion: 'Whether to confirm deletion?',
    selectData: 'Please select data',
    chooseDate: 'Please select a date',
    selectCompany: 'Please select company'
  },
  // 国家地区
  country: {
    country: 'Country',
    goodsType: 'Goods Type',
    countryInfo: 'Country Information',
    countryCode: 'Code',
    countryNameCn: 'Name(CN)',
    countryNameEn: 'Name(EN)',
    europeanFlag: 'Is European'
  },
  // 货物种类
  goodsType: {
    goodsType: 'Goods Type',
    goodsTypeInfo: 'Goods Type',
    goodsTypeCode: 'Code',
    cargoName: 'Name(EN)',
    cargoNameCn: 'Name(CN)',
    cargoGroupCode: 'CargoGroup',
    isDanagerousCargo: 'Dangerous Cargo',
    GENERALCARGOES: 'Genera Cargoes',
    COAL: 'Coal',
    AGRICULTURALPRODUCTS: 'Agricultural Products',
    NONMETALORE: 'Non-Metal Ore',
    STEELS: 'Steels',
    OTHER: 'Other',
    CEMENT: 'Cement (BULK)',
    SALT: 'Salt',
    BUILDINGMATERIAL: 'Building Material',
    GRAIN: 'Grain',
    TIMBER: 'Timber',
    Lightindustrialdrugs: 'Light Industrial Drugs',
    PETROLEUM: 'Petroleum',
    MACHINERYEQUIPMENT: 'Machinery Equipment',
    METALALLOY: 'Metal Alloy',
    FERTILIZER: 'Fertilizer',
    ONDECKCARGOES: 'On Deck Cargoes',
    LNG: 'Lng',
    METALORE: 'Metal Ore'
  },
  // 币种信息
  currency: {
    currency: 'Currency',
    currencyInfo: 'Currency Information',
    currencyCode: 'Code',
    currencyName: 'Name(CN)',
    currencySymbol: 'CurrencySymbol'
  },
  // 城市信息
  cityInfo: {
    cityInfo: 'City Information',
    cityCode: ' Code',
    cityNameCn: 'Name(CN)',
    cityNameEn: 'Name(EN)',
    countryCode: 'Country/Region',
    province: 'Province'
  },
  // 公司信息
  company: {
    companyInfo: 'Company Information',
    companyCode: 'Code',
    companyNameCn: 'Name(CN)',
    companyNameEn: 'Name(EN)',
    socialCreditCode: 'SocialCode',
    countryCode: 'CountryCode',
    mnemonicNo: 'MnemonicNo',
    registrationTime: 'Time',
    registrationAddress: 'Address'
  },
  // 汇率信息
  rate: {
    rateInfo: 'Exchange Rate Information',
    currencyFrom: 'CurrencyF',
    currencyTo: 'CurrencyT',
    dateRange: 'Date Range',
    effectDate: 'EffectDate',
    expireDate: 'ExpireDate',
    exchangeRate: 'Rate'
  },
  // 港口信息
  port: {
    portInformation: 'Port Information',
    portCode: 'Port Code',
    portCodeTitle: 'Port Information Maintenance',
    portNameCn: 'Name(CN)',
    portNameEn: 'Name(EN)',
    countryCode: 'Country',
    sendPortMaster: 'Send Master Data',
    addPortMaster: 'Add Main Data',
    editPortMaster: 'Edit Main Data'
  },
  portAssert: {
    tip: {
      checkAddPortMaster: 'Can only choose one piece !',
      addSuccess: 'Add Success',
      addError: 'Add Error',
      editSuccess: 'Edit Success',
      editError: 'Edit Error',
      sending: 'Sending, Please wait 10~30 second',
      sendSuccess: 'Send Success',
      sendError: 'Send Error'
    }
  },
  // 数据字典
  dataDictionary: {
    dictionary: 'Data Dictionary',
    codeType: 'Code Type',
    codeName: 'Code Name',
    codeLength: 'Code Length',
    remark: 'Remark',
    codeTab: 'Code Tab',
    showSeq: 'Seqno',
    code: 'Code',
    showVal: 'Displayvalue(EN)',
    showValCn: 'Displayvalue(CN)',
    relation: 'Relation Code',
    simpCode: 'Simple Code',
    remark2: 'Remark2',
    pleaseInput: 'please Enter Code Type',
    dictionaryAdd: 'Dictionary Add',
    dictionaryEdit: 'Dictionary Edit'
  },
  // 银行信息
  bankInfo: {
    bankInfomation: 'Bank Information',
    bankCode: ' Code',
    bankName: 'Bank Name',
    bankCount: ' Acount',
    countryOrRegion: 'Country/Region',
    countName: 'Count Name',
    bankAds: 'Bank Ads',
    bankCodeVal: 'Bank Code',
    receiptOrPaymentFlag: 'Receipt/Payment Flag',
    company: 'Company',
    countType: 'Count Type',
    companyCode: 'Company Code',
    companyNameCn: 'Company Name(CN)',
    companyNameEn: 'Company Name(EN)',
    countryOrRegionCode: 'Country/Region',
    countryOrRegionNameCn: 'Country/RegionName(CN)',
    countryOrRegionNameEn: 'Country/RegionName(EN)',
    receipt: 'Receipt',
    payment: 'Payment',
    receiptOrPayment: 'Receipt/Payment',
    mulCurrency: 'Mul Currency',
    dollar: 'Dollar',
    HKDollarDeposits: 'HK Dollar Deposits',
    HKDollarCheck: 'HK Dollar Check',
    notNull: 'Not Null',
    pleaseChooseState: 'Please Choose Status',
    pleaseChooseCompany: 'Please Choose Company',
    pleaseChooseCount: 'Please Choose Count'
  },
  // 业务科目
  costAccount: {
    title: 'Cost Account',
    assignmentMapping: 'Assignment Mapping',
    showInvalid: 'Show Invalid',
    showEffect: 'Show Effect',
    costCode: 'Cost Code',
    costName: ' Name(EN)',
    costNameCn: ' Name(CN)',
    businessType: 'Business Type',
    safetyProductionType: 'Safety Production Type',
    otherSafetyProductionType: 'Other Safety Production Type',
    reportSeq: 'Report Seq',
    inputNum: 'Input number',
    domesticTaxRate: 'Domestic TaxRate',
    isAssignmentMapping: 'Is Assignment Mapping',
    effectTime: 'Effect Time',
    invalidTime: 'Invalid Time',
    costMsg: 'Cost Message',
    costMaintain: 'Cost Maintain',
    hasChild: 'Has Child',
    isUsed: 'Isused',
    remark: 'Remark',
    companyNameCn: 'Company Name(CN)',
    companyNamECn: 'Company Name(EN)',
    company: 'Company',
    creator: 'Creator',
    yes: 'Yes',
    no: 'No',
    chooseDate: 'Choose Date',
    enterCostCode: 'Enter Costcode',
    enterCostName: 'Enter Costname(EN)',
    enterCostNameCn: 'Enter CostName(CN)',
    chooseEffectTime: 'Choose EffectTime',
    notNull: 'Not Null',
    portVoyageCost: 'Is Port Charge Voyage Cost'
  },
  // 数据库表
  dataBase: {
    dataForm: 'Database Table',
    tableName: 'Table Name',
    tableDesc: 'Table Desc',
    focus: 'Focus Vessel',
    columnName: 'Filed Name',
    columnDesc: 'Filed Desc',
    dataType: 'Filed Type',
    create: 'Database Add',
    edit: 'Database Edit',
    tabaleNoEmpty: 'Table name is not null',
    creator: 'Creator',
    createTime: 'Create Time'
  },
  //付款单财务审批人员配置
  paymentFinApproverConfiguration: {
    title: 'Payment order financial approval personnel allocation',
    handleUser: 'handleUser'
  },
  //公司印章配置
  companySealConfiguration: {
    company: 'Company',
    seal: 'Seal',
    title: 'Company Seal Configuration',
    activeFlag: 'Is Active',
    active: 'active',
    inactive: 'inactive'
  }
};